export default {
  get_all_membership: {},
  get_membership: {},
  admin_membership: {},
  getCoupon: {},
  getAllFeatures: {},
  getAllCategory: {},
};
